import { PriorityCode } from '../enums/priority-code.enum';
import { InvestigationFieldValueEntity } from './investigation-field-value.entity';
import { InvestigationFileUploadEntity } from './investigation-file-upload.entity';
import { InvestigationAttachmentEntity } from './investigation-attachment.entity';

export class InvestigationEntity {
  // Create flow fields
  public id!: string;
  public investigationNumber!: string;
  public investigationTypeId!: string;
  public investigationFormVersionId!: string;
  public requestorUserId!: string;
  public priorityCode!: PriorityCode;
  public primaryAssigneeUserId!: string | null;
  public secondaryAssigneeUserId!: string | null;
  public involvedEmployeeIds!: string[];
  public fieldValues!: InvestigationFieldValueEntity[];
  public fileUploads!: InvestigationFileUploadEntity[];
  public attachments!: InvestigationAttachmentEntity[];
  public createdOn!: string;
  public updatedOn!: string;

  // Detail view fields (populated by GET /{id}, optional until loaded)
  public investigationTypeName?: string;
  public investigationTypeCategoryName?: string;
  public requestedByName?: string;
  public requestedByEmail?: string;
  public requestedByPhone?: string | null;
  public requestedByDivision?: string | null;
  public requestedByDepartment?: string | null;
  public primaryAssigneeName?: string | null;
  public secondaryAssigneeName?: string | null;
  public statusId?: string;
  public statusName?: string;
  public statusDisplayName?: string;
  public statusColor?: string;
  public statusCategoryId?: number;
  public statusCategoryName?: string;
  public priorityName?: string;
  public timeToResolveHours?: number | null;
  public atRiskThresholdPercent?: number | null;
  public dueDate?: string | null;
  public createdByUserId?: string;
  public createdByUserName?: string;
  public watcherCount?: number;
  public isCurrentUserWatching?: boolean;
  public closingReasonId?: string | null;
  public closingReasonName?: string | null;
  public closingNotes?: string | null;
  public closedOn?: string | null;
  public closedByUserId?: string | null;
  public closedByUserName?: string | null;
  public conversionReasonId?: string | null;
  public conversionReasonName?: string | null;
  public conversionNotes?: string | null;
  public convertedOn?: string | null;
  public convertedByUserId?: string | null;
  public convertedByUserName?: string | null;
  public isInvestigation?: boolean;

  // Transfer-to-ER (HCMI-796): sourceCaseNumber is non-null iff the investigation was created
  // via Case→ER transfer — the UI keys off it for the read-only "Submission from Shared Services"
  // banner. isPendingReclassification stays true only until the intake user picks a real ER type.
  public sourceCaseNumber?: string | null;
  public isPendingReclassification?: boolean;

  // Workflow (approvals & delegations)
  public workflowSubStatus?: string | null;
  public isReadOnly?: boolean;
  public currentWorkflowHandoffTeamName?: string | null;
  public currentWorkflowHandoffTargetUserName?: string | null;
}
